










import Vue from 'vue';
import {Component} from "vue-property-decorator";
import AsiPageTitle from "@/components/common/AsiPageTitle.vue";
import {Icon} from "@/helpers/icons";
import CompanyList from "@/components/company/CompanyList.vue";
import CompanyCreateDialog from "@/components/company/CompanyCreateDialog.vue";
import {Permissions} from "@/helpers/constants";

@Component({
	components: {
		CompanyList,
		CompanyCreateDialog,
		AsiPageTitle,
	}
})
export default class Companies extends Vue {

	private createDialogOpen = false;
	private icons = Icon;

	private get isMasterData(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightMasterData);
	}

}
